import React from 'react';
import { PAPER_TABS } from '../data/common';

export const setToken = token => {
  localStorage.setItem(`cedu-front-token`, token);
};

// $명$은 제거하고, ||은 ;로 변경
export const strParse = str => {
  if (str === '' || str === undefined || str === null) return '';
  return (
    str
      // $명$ 형식을 제거하고 뒤 공백 제거
      .replace(/\s*\$.*?\$\s*/g, '')
      // ||를 ;로 변경하고 앞의 공백 제거, 뒤에 공백 추가
      .replace(/\s*\|\|\s*/g, '; ')
      // 중복된 공백을 하나로 줄임
      .replace(/\s+/g, ' ')
      // 양 끝 공백 제거
      .trim()
  );
};

export const strFirstMeaning = str => {
  if (!str) return '';
  return (
    str
      // `$명$` 패턴을 포함하여 제거
      .replace(/\s*\$.*?\$\s*/g, '')
      // `||`를 `;`로 변경
      .replace(/\s*\|\|\s*/g, '; ')
      // `;` 이후 내용 제거 → 앞의 문자열만 남김
      .split(/[;]/)[0]
      // 중복된 공백을 하나로 줄임
      .replace(/\s+/g, ' ')
      .trim()
  );
};

// {be^proud^of}에서 '시험지만'이면 분기되는 개수 리턴, '정답/시험지'면 {}없애고 ^기준으로 나눈 단어 배열 리턴
export const makeStrs = (str, condition) => {
  if (condition === PAPER_TABS.TEST_PAPER) {
    return str?.split('^')?.length;
  } else if (condition === PAPER_TABS.ANSWER) {
    // 모든 문장부호와 {}를 제거
    return str?.replace(/[{}!@#$%&*()?><":;.,]/g, '')?.split('^');
  }
};

// {be^proud^of}에서 '시험지만' & '첫글자'일 때
export const makeStrsSeperate = str => {
  return str?.replace(/[{}!@#$%&*()?><":;.,]/g, '')?.split('^');
};

// J유형 영문 {} -> bold처리
export const makeBold = text => {
  const parts = text?.split(/(\{.*?\})/g); // 중괄호 기준으로 분리
  return parts?.map((part, index) =>
    part?.startsWith('{') && part?.endsWith('}') ? (
      <b style={{ borderBottom: '1px solid black' }} key={index}>
        {part?.slice(1, -1)?.replace(/\^/g, ' ')}
      </b> // 중괄호 제거하고 <b>로 감싸기
    ) : (
      part
    ),
  );
};

// K유형 영문 {} -> ____ 밑줄 처리
export const makeBlank = text => {
  const parts = text?.split(/(\{.*?\})/g); // 중괄호 기준으로 분리
  const result = parts?.map((part, index) =>
    part?.startsWith('{') && part?.endsWith('}') ? (
      <span key={index}>_______________</span>
    ) : (
      part
    ),
  );
  return result;
};

// k유형 문제에서 () 부분 폰트사이즈 작게 하기 위한 함수
export const makeFontSizeDiff = str => {
  const match = str.match(/\(.*?\)/);
  if (match) {
    return [str.replace(match[0], '').trim(), match[0]];
  }
  return [str];
};

// L유형 '유의어', '반의어'에서 언더라인 처리
export const makeUnderLine = (text, target) => {
  const parts = text.split(target); // 대상 문자열을 기준으로 분할
  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index < parts.length - 1 && (
            <u style={{ fontWeight: 900 }}>{target}</u>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

// L유형 언더라인 워드용
export const makeUnderLineForDocx = (text, target) => {
  const parts = text?.split(target);
  let result = [];
  parts?.forEach((part, index) => {
    result.push(part);
    if (index < parts.length - 1) {
      result.push(target);
    }
  });
  return result;
};

// export const urlToBase64 = async imageUrl => {
//   const response = await fetch(imageUrl);
//   const blob = await response.blob();
//   return new Promise(resolve => {
//     const reader = new FileReader();
//     reader.readAsDataURL(blob);
//     reader.onloadend = () => resolve(reader.result);
//   });
// };

export const urlToBase64 = async imageUrl => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // ✅ CORS 문제 우회
    img.src = imageUrl;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const base64String = canvas.toDataURL('image/png'); // ✅ Base64 변환
      resolve(base64String);
    };
    img.onerror = error => reject(error);
  });
};
